import { useTranslation } from 'react-i18next';
import { LegalPageLayout, LegalSection } from './LegalPageLayout';

const SECTIONS = [
  'service',
  'aiDisclaimer',
  'ownership',
  'acceptableUse',
  'liability',
  'termination',
  'changes',
  'contact',
] as const;

export function TermsPage() {
  const { t } = useTranslation();

  return (
    <LegalPageLayout titleKey="legal.termsTitle">
      <p>{t('terms.intro')}</p>
      {SECTIONS.map((key) => (
        <LegalSection key={key} titleKey={`terms.${key}Title`}>
          <p className="mt-1 text-muted-foreground">{t(`terms.${key}Text`)}</p>
        </LegalSection>
      ))}
    </LegalPageLayout>
  );
}
